module.exports = __webpack_public_path__ + "img/whats-new-17_en.5218b8d.jpg";